<script setup lang="ts">
import { AvatarWithFallback } from '~/components/ui/avatar'
import type { FeedVacancyItem } from '~/entities/feed'
import LandingVideo from './LandingVideo.vue'

const props = defineProps<{ item: FeedVacancyItem }>()

const first = computed(() => props.item.videos[0] ?? null)
const salary = computed(() => {
  const { min, max } = props.item.vacancy.salary
  const value = min ?? max
  return value ? `${min ? 'от ' : 'до '}${value.toLocaleString('ru-RU')} ₽` : null
})
</script>

<template>
  <div class="relative aspect-[4/5] overflow-hidden rounded-3xl bg-neutral-900 text-white shadow-2xl lg:aspect-9/16">
    <LandingVideo v-if="first" :src="first.src" :poster="first.poster" class="absolute inset-0 size-full object-cover" />
    <div class="absolute inset-0 flex flex-col justify-end bg-linear-to-t from-black/80 via-black/5 to-black/20 p-5">
      <span class="absolute left-5 top-5 flex items-center gap-1 rounded-full bg-black/40 px-2.5 py-1 text-xs font-medium backdrop-blur">
        <Icon name="tabler:player-play-filled" class="size-3" />
        {{ item.videos.length }} видео
      </span>
      <span class="absolute left-1/2 top-1/2 flex size-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white/25 backdrop-blur">
        <Icon name="tabler:player-play-filled" class="size-7" />
      </span>
      <span class="flex items-center gap-2">
        <AvatarWithFallback :src="item.vacancy.company.logo" :name="item.vacancy.company.name" class="size-8 shrink-0" />
        <span class="truncate text-sm uppercase tracking-wide opacity-90">{{ item.vacancy.company.name }}</span>
      </span>
      <span class="mt-1 line-clamp-2 text-2xl font-semibold leading-tight">{{ item.vacancy.title }}</span>
      <span v-if="salary" class="mt-0.5 opacity-90">{{ salary }}</span>
    </div>
  </div>
</template>
